/**
 * Native-shell bootstrap (src/platform/).
 *
 * Called once from main.tsx. On web this is a complete no-op — the web
 * bundle's behavior is untouched. Inside the Capacitor shells it wires the
 * native seams:
 *  - keyboard: hides the iOS accessory bar (viewport resize is config-side)
 *  - back button: pops SPA history / exits at root (Android hardware back)
 *  - share-target: media shared from the OS share sheet → upload queue
 *  - push: NOT registered here (#2567) — asking for notification permission
 *    at launch/login asks for something the user hasn't seen a reason for
 *    yet. Registration is offered contextually, after a qualifying in-app
 *    event, via platform/pushPrompt.ts (wired from AppShell).
 */

import { initBackButton } from './backButton'
import { isNativePlatform } from './detection'
import { initKeyboard } from './keyboard'
import { initShareTarget } from './shareTarget'
import { enqueueUploads } from './upload'

/** Wire native-shell capabilities; no-op on the plain web app. */
export function initNativePlatform(): void {
  if (!isNativePlatform()) return
  initKeyboard()
  initBackButton()
  void initShareTarget((files) => enqueueUploads(files))
}
